import React from 'react'
import { InputSwitch } from 'primereact/inputswitch'
import { useTranslation } from 'react-i18next'
import DropdownField from '../../../shared/DropdownField'

const defaults = {
  template: 'standard_medical_report',
  show_business_logo: true,
  show_chai_logo: false,
  show_vision_2030_logo: false,
  chai_logo_url: '',
  vision_2030_logo_url: '',
}

export default function MedicalReportTemplateSettings({ settings, updateSettings, updateLoading }) {
  const { t } = useTranslation()
  const setting = settings?.invoice_size
  const medical = { ...defaults, ...(setting?.medical_report_settings || {}) }
  const change = values => updateSettings({ ...setting, medical_report_settings: { ...medical, ...values } })

  if (!setting?.id) return <section className='rounded-xl border bg-white p-5 text-sm text-gray-500'>{t('Medical Report settings are not available')}</section>

  return <section className='overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm'>
    <div className='border-b bg-gray-50 px-5 py-4'>
      <h2 className='text-base font-semibold text-gray-800'>{t('Medical Report Settings')}</h2>
      <p className='mt-1 text-sm text-gray-500'>{t('Configure the template and branding used for medical report viewing and printing')}</p>
    </div>
    <div className='space-y-6 p-5'>
      <div>
        <label className='mb-2 block text-sm font-semibold'>{t('Report Template')}</label>
        <DropdownField
          useFormik={false}
          name='medical_report_template'
          label={t('Template')}
          value={medical.template}
          handleChange={e => change({ template: e.value })}
          options={[
            { label: t('Standard Medical Report'), value: 'standard_medical_report' },
            { label: t('Medical Report with CHBAI Format'), value: 'medical_report_chai_format' },
          ]}
          disabled={updateLoading}
        />
      </div>
      <div>
        <h3 className='mb-3 text-sm font-semibold'>{t('Report Branding')}</h3>
        {[['show_business_logo', 'Business Logo'], ['show_chai_logo', 'CHAI Logo'], ['show_vision_2030_logo', 'Saudi Vision 2030 Logo']].map(([key, label]) => <div key={key} className='flex items-center justify-between border-b py-3'><span className='text-sm'>{t(label)}</span><InputSwitch checked={medical[key]} onChange={e => change({ [key]: e.value })} disabled={updateLoading} /></div>)}
      </div>
    </div>
  </section>
}
